<template>
  <div class='sub-content' > <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='bom-main float-left'>
      <dx-data-grid ref='refBomMainGrid'
        :data-source='prodctInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="품번"
        :focused-row-key.sync='focusedRowKey'
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="완제품리스트"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
         <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품번"
            data-field="품번"
          >
              <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="품명"
            data-field="품명"
            :visible='true'
          >
              <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            caption="자재유형"
            data-field="자재유형"
          >
            <DxLookup
              :data-source="meterialTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="공정유형"
            data-field="공정유형"
            :visible='true'
          >
            <DxLookup
              :data-source="processingTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="단위"
            data-field="단위"
            :visible='true'
          >
            <dx-required-rule message="항목을 선택하세요"/>
            <DxLookup
              :data-source="unitLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="사용유무"
            data-field="사용유무"
            :visible='false'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="삭제유무"
            data-field="삭제유무"
            :visible='false'
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <!-- ******************************** BOM SUB ***************************-->
    <!-- ******************************** BOM SUB ***************************-->
    <!-- ******************************** BOM SUB ***************************-->
    <div class='bom-sub-tree float-left'>
      <dx-tree-list
        ref="refBomSubGrid"
        :height='gridHeight'
        :data-source="bomInfoList"
        :autoExpandAll='true'
        :show-borders="true" :showRowLines = 'true'
        :column-auto-width="true"
        :hover-state-enabled = "true"
        key-expr="seqId"
        parent-id-expr="parentSeqId"
        :selection="{ mode: 'single' }"
        :focused-row-enabled="true"
        :allow-column-resizing="true"
        column-resizing-mode="nextColumn"
        @toolbar-preparing='onToolbarPreparingSub'
        @cellPrepared='onCellPreparedBom'
        @rowDblClick="onRowDblClickBom"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <!--
        <DxEditing
          :allow-adding="false"
          :allow-updating="false"
          :allow-deleting="false"
          :use-icons="true"
          mode="row"
        />-->
        <dx-column
          :allowEditing='false'
          data-field="품번"
          caption="품번"
          :allow-sorting="true"
        />
        <dx-column
          :allowEditing='false'
          data-field="품명"
          caption="품명"
          :allow-sorting="true"
        />
        <DxColumn
          :allowEditing='true'
          caption="원수"
          data-field="수량"
          :visible='true'
          format='#,##0.00'
          dataType="number"
        >
          <dx-required-rule message="항목을 립력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
        >
          <DxLookup
            :data-source="productypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="자재유형"
          data-field="자재유형"
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="공정유형"
          data-field="공정유형"
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
          :visible='true'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="발주사"
          data-field="납품처코드"
          :visible='true'
        >
           <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn v-if="$store.getters.getGroupName !== null"
          :allowEditing='true'
          :caption="$store.getters.getGroupName"
          data-field="차종"
          :visible='true'
        >
           <DxLookup
            :data-source="carTypeLookup"
            display-expr="모델명"
            value-expr="모델코드"
          />
        </DxColumn>
        <DxScrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <DxPaging :enabled="false"/>
        <template #bom-sub-tree>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
              <b v-if='selectedRow'>BOM ({{selectedRow.품명}} : {{selectedRow.품번}})</b>
            </div>
        </template>
      </dx-tree-list>
    </div>
    <DxPopupGen
      :visible.sync="popupForwardBom"
      :drag-enabled="true"
      :close-on-outside-click="true"
      :show-title="true"
      :width="840"
      :height="680"
      title="완제품 정전개"
    >
      <dx-tree-list
        ref="refForwardBomSubGrid"
        height='600'
        :data-source="bomForwardInfoList"
        :autoExpandAll='true'
        :show-borders="true" :showRowLines = 'true'
        :column-auto-width="true"
        :hover-state-enabled = "true"
        key-expr="seqId"
        parent-id-expr="parentSeqId"
        :selection="{ mode: 'single' }"
        :focused-row-enabled="true"
        :allow-column-resizing="true"
        column-resizing-mode="nextColumn"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxColumn
          :allowEditing='false'
          data-field="품번"
          caption="품번"
        />
        <DxColumn
          :allowEditing='false'
          data-field="품명"
          caption="품명"
          width="120"
        />
        <DxColumn
          :allowEditing='true'
          caption="원수"
          data-field="수량"
          :visible='true'
          format='#,##0.00'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
        >
          <DxLookup
            :data-source="productypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="자재유형"
          data-field="자재유형"
          :visible="false"
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          data-field="거래처명"
          caption="거래처명"
        />
        <DxColumn
          caption="공정유형"
          data-field="공정유형"
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          data-field="재질"
          caption="재질"
        />
        <DxColumn
          :allowEditing='false'
          data-field="규격"
          caption="규격"
          width="90"
        />
        <DxScrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <DxPaging :enabled="false"/>
      </dx-tree-list>
    </DxPopupGen>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel,
  DxLookup } from 'devextreme-vue/data-grid'
import { DxTreeList } from 'devextreme-vue/tree-list'
import { DxRequiredRule } from 'devextreme-vue/validator'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      // 제품리스트
      prodctInfoList: null,
      gridHeight: null,
      selectedRow: null,
      focusedRowKey: null,
      processingTypeLookup: null,
      unitLookup: null,
      selectedPrductType: null,
      meterialTypeLookup: null,
      // BOM
      bomInfoList: null,
      bomReportFile: 'bom',
      divisionList: null,
      selectedRowBom: null,
      nodeExpandBtn: null,
      // popup 완제품BOM
      popupForwardBom: false,
      bomForwardInfoList: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxRequiredRule,
    DxTreeList,
    DxPopupGen
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.selectedPrductType = ConstDef.다공정품
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.carTypeLookup = this.$store.getters.getCarType
    this.customerLookup = this.$store.getters.getCustomerInfo
    this.refreshProductList(this.selectedPrductType)
    this.refreshBomList()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    // ****************** 제품 Grid ************************************
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
      this.bomReportFile = `BOM_${this.selectedRow.품명}_${this.selectedRow.품번}`
      this.resetNodeBtnCollapseRow()

      this.$refs.refBomSubGrid.instance.filter(['품번', '=', this.selectedRow.품번])
      let result = this.$refs.refBomSubGrid.instance.getDataSource()
      setTimeout(() => {
        if (result === null || result._items.length === 0) {
          this.$snotify.info('해당 품목은 BOM구성이 되어있지 않습니다.', { timeout: 500 })
        }
      }, 100)
    },
    onToolbarPreparing (e) {
      let productypeLookup = this.$_.reject(this.productypeLookup, function (d) { return d.코드 === ConstDef.완제품 })
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>품목유형: </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 100,
            items: productypeLookup,
            valueExpr: '코드',
            displayExpr: '코드명',
            value: this.selectedPrductType,
            onValueChanged: (args) => {
              this.selectedPrductType = args.value
              this.refreshProductList(this.selectedPrductType)
            }
          }
        }
      )
    },
    refreshProductList (code) {
      this.isLoading = true
      let storeProc = 'spFindAllProductByType'
      this.$_sp.runNoEncodeFindProc(storeProc, { 품목유형: code })
        .then((data) => {
          this.prodctInfoList = this.$_sp.MakeModel(data)
          this.gridHeight = (screen.height - 250) * 0.95
          if (this.bomInfoList !== null) {
            this.isLoading = false
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // ****************** BOM Grid ************************************
    // ****************** BOM Grid ************************************
    // ****************** BOM Grid ************************************
    onCellPreparedBom (e) {
      // console.log(e)
      if (e.rowType === 'data' && e.data.품번 === this.selectedRow.품번) {
        this.$Q(e.cellElement).css('color', 'red')
      }
    },
    onRowDblClickBom (row) {
      console.log(row)
      if (row.data.상위품번 === null) {
        this.refreshForwardBomList(row.data.품번)
      }
    },
    onToolbarPreparingSub (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'bom-sub-tree'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'chevronup',
            type: 'default',
            text: '노드 축소',
            disabled: true,
            focusStateEnabled: true,
            onInitialized: (args) => {
              this.nodeExpandBtn = args.component
            },
            onClick: (args) => {
              // // console.log(args)
              let vm = this
              if (this.nodeExpandBtn.option().text === '노드 축소') {
                this.$refs.refBomSubGrid.instance.forEachNode(function (node) {
                  vm.$refs.refBomSubGrid.instance.collapseRow(node.key)
                })
                this.nodeExpandBtn.option({ icon: 'chevrondown', text: '노드 확장' })
              } else {
                this.$refs.refBomSubGrid.instance.forEachNode(function (node) {
                  vm.$refs.refBomSubGrid.instance.expandRow(node.key)
                })
                this.nodeExpandBtn.option({ icon: 'chevronup', text: '노드 축소' })
              }
            }
          }
        }
      )
    },
    resetNodeBtnCollapseRow () {
      // // console.log('fskfjsjflsjflj')
      this.nodeExpandBtn.option({ icon: 'chevronup', text: '노드 축소', disabled: false })
    },
    resetNodeBtnExpandRow () {
      // // console.log('fskfjsjflsjflj')
      this.nodeExpandBtn.option({ icon: 'chevrondown', text: '노드 확장', disabled: false })
    },
    refreshBomList () {
      // refBomSubGrid
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllBomReverse', { 대수: 1 })
        .then((data) => {
          this.bomInfoList = this.$_sp.MakeModel(data)
          setTimeout(() => {
            this.$refs.refBomSubGrid.instance.filter(['품번', '=', 'none'])
          }, 0)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      this.isLoading = false
    },
    refreshForwardBomList (productCode) {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllBomForwardDetailByProductCode', { title: 'bomForward', 완제품코드: productCode, 대수: 1 })
        .then((data) => {
          this.bomForwardInfoList = this.$_sp.MakeModel(data)
          console.log(this.bomForwardInfoList)
          this.isLoading = false
          if (this.bomInfoList.length === 0) {
            this.$snotify.info('등록된 BOM이 없습니다.')
          } else {
            this.popupForwardBom = true
            setTimeout(() => {
              let vm = this
              this.$refs.refForwardBomSubGrid.instance.forEachNode(function (node) {
                vm.$refs.refForwardBomSubGrid.instance.expandRow(node.key)
              })
            }, 300)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.sub-content{
  .bom-main{
    width:40%;
    margin-right:2%;
    border:0px solid red;
    min-height: 500px;
  }
  .bom-sub-tree{
    width:58%;
    border:0px solid red;
    min-height: 500px;
  }
}
</style>
